import api from '../api';

export const startTestApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllCompany: builder.query({
      query: () => ({
        url: '/api/company/fetchall',
        method: 'GET'
      })
    }),
    getCompaniesByType: builder.query({
      query: ({ companyStatusCode }) => ({
        url: '/api/company/fetchallcompanies',
        method: 'GET',
        params: { companyStatusCode }
      })
    }),
    getCompanyPattern: builder.query({
      query: ({ testAssignmentId, testSetId }) => ({
        url: '/api/usertest/start/test',
        method: 'POST',
        params: { testAssignmentId, testSetId }
      })
    }),
    getGenerationalSectionalTest: builder.mutation({
      query: body => ({
        url: '/test/generation/sectional/test',
        method: 'POST',
        body
      })
    }),
    getALlRounds: builder.query({
      query: () => ({
        url: '/api/rounds/fetchall',
        method: 'GET'
      })
    }),
    getAllSectionsData: builder.query({
      query: roundId => ({
        url: '/api/section/fetchall',
        method: 'GET'
      })
    }),
    softSaveTest: builder.mutation<
      any,
      { userTestId: string; testSetId: string; payload: any }
    >({
      query: ({ userTestId, testSetId, payload }) => ({
        url: '/api/usertest/soft/save/user/test',
        method: 'POST',
        body: payload,
        params: { userTestId, testSetId }
      })
    }),
    discardTest: builder.mutation<
      any,
      { userTestId: string; testSetId: string }
    >({
      query: ({ userTestId, testSetId }) => ({
        url: '/api/usertest/discrad/test',
        method: 'POST',
        params: { userTestId, testSetId }
      })
    }),
    resumeTest: builder.query<any, { userTestId: string; testSetId: string }>({
      query: ({ userTestId, testSetId }) => ({
        url: '/api/usertest/resume/test',
        method: 'GET',
        params: { userTestId, testSetId }
      })
    }),
    saveTest: builder.mutation<any, { userTestId: string; payload: any }>({
      query: ({ userTestId, payload }) => ({
        url: '/api/usertest/saveusertest',
        method: 'PUT',
        body: payload,
        params: { userTestId }
      })
    }),
    endTest: builder.mutation<any, { userTestId: string }>({
      query: ({ userTestId }) => ({
        url: '/api/usertest/endtest',
        method: 'PUT',
        params: { userTestId }
      })
    }),
    processTestActivity: builder.mutation<any, { userTestId: string }>({
      query: ({ userTestId }) => ({
        url: '/api/usertest/processactivity',
        method: 'PUT',
        params: { userTestId }
      })
    }),
    getTestResults: builder.query<
      any,
      { size: number; page: number; userId: string }
    >({
      query: ({ size, page, userId }) => ({
        url: '/api/usertest/fetchusertests',
        method: 'GET',
        params: { size, page, userId }
      })
    }),
    getTestResultById: builder.query<
      any,
      { userTestId: string; userId: string }
    >({
      query: ({ userTestId, userId }) => ({
        url: '/api/usertest/fetchusertest',
        method: 'GET',
        params: { userTestId, userId }
      })
    }),
    getCodeingEvaluation: builder.mutation({
      query: payload => ({
        url: '/api/usertest/computing/program',
        method: 'POST',
        body: payload
      })
    }),
    removeUserTest: builder.mutation({
      query: userTestId => ({
        url: '/api/usertest/removeusertest',
        method: 'DELETE',
        params: { userTestId }
      })
    }),
    getTestsForCompany: builder.query({
      query: ({ companyId, totalTestCount }) => ({
        url: '/api/usertest/assigned/tests',
        method: 'GET',
        params: { companyId, totalTestCount }
      })
    }),
    sendTestActivity: builder.mutation({
      query: body => ({
        url: '/api/usertest/addactivity',
        method: 'POST',
        body
      })
    }),
    getProgrammingTopics: builder.query({
      query: () => ({
        url: '/api/topic/section/topics',
        method: 'GET'
      })
    }),
    startProgrammingTest: builder.query({
      query: ({ topicId }) => ({
        url: '/api/programming/test/starttest',
        method: 'GET',
        params: { topicId }
      })
    }),
    submitProgrammingTest: builder.mutation({
      query: body => ({
        url: '/api/programming/test/submittest',
        method: 'POST',
        body
      })
    }),
    getProgrammingUserTests: builder.query({
      query: ({ page, size, userId }) => ({
        url: '/api/programming/test/getusertests',
        method: 'GET',
        params: { page, size, userId }
      })
    }),
    getProgrammingUserTestById: builder.query({
      query: ({ userTestId, userId }) => ({
        url: '/api/programming/test/getusertest',
        method: 'GET',
        params: { userTestId, userId }
      })
    }),
    compileProgram: builder.mutation({
      query: body => ({
        url: '/api/compiler/compile',
        method: 'POST',
        body
      })
    }),
    getInstructionsForTest: builder.query({
      query: testId => ({
        url: 'api/usertest/test/instructions',
        method: 'GET',
        params: { testId }
      })
    }),
    getCodingCategories: builder.query({
      query: () => ({
        url: '/api/category/tags/get/categorynames',
        method: 'GET'
      })
    }),
    getCategoryQuestions: builder.query({
      query: ({ categoryId }) => ({
        url: '/api/programming/categories/questions',
        method: 'GET',
        params: { categoryId }
      })
    }),
    getCategoryQuestionData: builder.mutation({
      query: ({ categoryId, questionId }) => ({
        url: '/api/programming/categories/start/test',
        method: 'POST',
        params: { categoryId, questionId }
      })
    }),
    submitCategoryQuestion: builder.mutation({
      query: body => ({
        url: '/api/programming/categories/submit/test',
        method: 'POST',
        body
      })
    }),
    programmingCategoryResult: builder.query({
      query: ({ categoryId, questionId }) => ({
        url: '/api/programming/categories/results',
        method: 'GET',
        params: { categoryId, questionId }
      })
    }),
    getDriveTableResults: builder.query({
      query: ({ page, size, userId }) => ({
        url: 'api/drive/test/fetchusertests',
        method: 'GET',
        params: { page, size, userId }
      })
    }),
    getDriveResult: builder.query({
      query: ({ userTestId, userId }) => ({
        url: 'api/drive/test/fetchusertest',
        method: 'GET',
        params: { userTestId, userId }
      })
    }),
    getMockTest: builder.mutation({
      query: ({ userId }) => ({
        url: 'api/company/mock/user/test/get/test',
        method: 'POST',
        params: { userId }
      })
    }),
    saveMockTest: builder.mutation({
      query: ({ userId, userTestId, payload }) => ({
        url: 'api/company/mock/user/test/save/test',
        method: 'PUT',
        params: { userId, userTestId },
        body: payload
      })
    }),
    fetchMockTestResuls: builder.query({
      query: ({ userId, userTestId }) => ({
        url: 'api/company/mock/user/test/results',
        method: 'GET',
        params: { userId, userTestId }
      })
    }),
    fetchMockTestPricing: builder.query({
      query: () => ({
        url: 'api/mock/test/pricing/fetch/all',
        method: 'GET'
      })
    })
  })
});

export const {
  useGetAllCompanyQuery,
  useLazyGetCompanyPatternQuery,
  useGetALlRoundsQuery,
  useGetAllSectionsDataQuery,
  useSaveTestMutation,
  useEndTestMutation,
  useLazyGetTestResultsQuery,
  useLazyGetTestResultByIdQuery,
  useGetTestResultByIdQuery,
  useGetCodeingEvaluationMutation,
  useRemoveUserTestMutation,
  useLazyGetTestsForCompanyQuery,
  useLazyResumeTestQuery,
  useSoftSaveTestMutation,
  useDiscardTestMutation,
  useSendTestActivityMutation,
  useGetGenerationalSectionalTestMutation,
  useProcessTestActivityMutation,
  useGetProgrammingTopicsQuery,
  useLazyStartProgrammingTestQuery,
  useSubmitProgrammingTestMutation,
  useLazyGetCompaniesByTypeQuery,
  useGetProgrammingUserTestsQuery,
  useLazyGetProgrammingUserTestsQuery,
  useGetProgrammingUserTestByIdQuery,
  useCompileProgramMutation,
  useLazyGetInstructionsForTestQuery,
  useGetCodingCategoriesQuery,
  useLazyGetCategoryQuestionsQuery,
  useGetCategoryQuestionDataMutation,
  useSubmitCategoryQuestionMutation,
  useLazyProgrammingCategoryResultQuery,
  useGetDriveTableResultsQuery,
  useLazyGetDriveTableResultsQuery,
  useGetDriveResultQuery,
  useGetMockTestMutation,
  useSaveMockTestMutation,
  useFetchMockTestResulsQuery,
  useFetchMockTestPricingQuery
} = startTestApi;
